{
  "cms.article.action.publish": "Publish to production",
  "cms.article.action.retry": "Retry",
  "cms.article.action.saveDraft": "Save draft",
  "cms.article.accordion.add": "Add accordion item",
  "cms.article.blocks.addText": "Add free text",
  "cms.article.blocks.empty": "No content",
  "cms.article.blocks.heading": "Content",
  "cms.article.blocks.removeText": "Remove free text",
  "cms.article.blocks.textLabel": "Free text",
  "cms.article.blocks.summaryFilled": "(has content)",
  "cms.article.blocks.summaryEmpty": "(empty)",
  "cms.article.blocks.done": "OK",
  "cms.article.accordion.itemTitle": "Accordion",
  "cms.article.accordion.noTitle": "(no title)",
  "cms.article.accordion.remove": "Remove accordion item",
  "cms.article.field.accordion": "Accordion (optional)",
  "cms.article.field.accordion.bodyHtml": "Body (HTML)",
  "cms.article.field.accordion.title": "Title",
  "cms.article.field.bodyHtml": "Body (HTML)",
  "cms.article.field.heroImage": "Hero image",
  "cms.article.field.slug": "URL slug",
  "cms.article.field.slug.lockedHelp": "Slug is locked after publish to preserve link stability.",
  "cms.article.field.title": "Title",
  "cms.article.error.heroImageHttps": "Hero image URL must start with https:// or be a same-origin path (/media/...).",
  "cms.article.error.slugFormat": "Slug must contain only lowercase letters, digits, and hyphens (a–z, 0–9, -).",
  "cms.article.error.titleRequired": "Title is required.",
  "cms.article.error.titleNotDerivable": "The title must contain at least one Latin letter or number.",
  "cms.article.publishContract.body": "Draft shows only in preview. Publish moves changes to production and stores a version.",
  "cms.article.linkedCard.title": "Home card",
  "cms.article.linkedCard.tabLabel": "Shown on tab",
  "cms.article.linkedCard.tab.none": "No card",
  "cms.article.linkedCard.tab.lakikaveri": "Lakikaveri",
  "cms.article.linkedCard.tab.palvelut": "Membership & benefits",
  "cms.article.linkedCard.help": "The card appears on the home page on the chosen tab and links to this article.",
  "cms.article.linkedCard.creating": "Creating the home-page card…",
  "cms.article.linkedCard.unitMemberDissociationBlocked": "The card and the page form a published publication unit and the card cannot be unlinked yet. Archive the whole unit from the content catalog.",
  "cms.article.linkedCard.createError": "Creating the card failed. Retry by picking a tab again.",
  "cms.article.linkedCard.createBlockedInvalidSlug": "Save the article with a valid URL slug before adding a card.",
  "cms.article.linkedCard.error.partialSave": "Article saved, but saving the card failed. Try again."
}
